<template>
  <div class="common-header">
    <div v-if="$slots.action" class="action">
      <slot name="action" />
    </div>
    <h2>{{ title }}</h2>
    <p v-if="description">{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    description?: string
  }>(),
  {
    title: 'Titre'
  }
)
</script>

<style scoped lang="scss">
.common-header {
  background-color: #f0f1f5;
  padding: 30px;
  min-height: 100px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 20px;
}

.action {
  top: 45px;
  left: 30px;
}

.common-header h2 {
  color: var(--vc-dark);
  font-size: 38px;
  font-weight: 600;
  font-family: 'Jost';
}

.common-header p {
  font-family: 'Roboto';
  font-size: 16px;
  font-weight: 400;
  color: var(--vc-dark);
  opacity: 75%;
}

@media screen and (min-width: 640px) {
  .common-header {
    padding: 80px 50px 40px 50px;
  }

  .action {
    position: absolute;
    left: 50px;
  }
}
</style>
